import { STATUS_FILTERS } from "./dashboard-filters";
import type { DashboardLineView } from "@/types/dashboard.types";

const COLUMNS = [
  "Linha",
  "Situação",
  "OEE %",
  "Disponibilidade %",
  "Performance %",
  "Qualidade %",
  "Aderência ao plano %",
  "Máquinas",
  "Disp 7d %",
  "Alarmes ativos",
  "Responsável",
  "Confiabilidade",
] as const;

function num(v: number | null | undefined, digits = 1): string {
  return v == null ? "" : v.toFixed(digits);
}

function cell(value: string | number): string {
  const s = String(value);
  return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

function situationLabel(line: DashboardLineView): string {
  if (line.activeAlarms > 0) return "Com alarme";
  return (
    STATUS_FILTERS.find((f) => f.id !== "todas" && f.id !== "alarme" && f.match(line))?.label ??
    "Ociosa"
  );
}

export function buildLinesCsv(lines: DashboardLineView[]): string {
  const header = COLUMNS.join(";");
  const rows = lines.map((l) =>
    [
      l.name,
      situationLabel(l),
      num(l.oee),
      num(l.availability),
      num(l.performance),
      num(l.quality),
      num(l.planAdherence),
      l.machineCount,
      l.availabilityEstimate7d == null ? "" : (l.availabilityEstimate7d * 100).toFixed(0),
      l.activeAlarms,
      l.responsible ?? "",
      l.reliability,
    ]
      .map(cell)
      .join(";")
  );
  return [header, ...rows].join("\n");
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
